import styled from "styled-components";
import { theme } from "../../config/theme";

export const StyleWrapper = styled.div`
  .fc {
    border-radius: 0.25rem;
    width: 32rem;
  }

  .fc-daygrid-day-frame {
    height: 5.25rem;
  }

  .fc-button.fc-prev-button,
  .fc-button.fc-next-button,
  .fc-button.fc-button-primary {
    padding: 0.4rem 0.4rem;
  }

  .fc .fc-button-primary {
    color: ${theme.font.color.black};
    background-color: white ;
    font-size: ${theme.font.size.small};
    border-color:  ${theme.color.primaryBorder};
  }

  .fc-button-group .fc-prev-button  {
    padding: 0.3rem 0.3rem;
  }

  .fc-toolbar-title {
    font-size: ${theme.font.size.large};
    font-weight: ${theme.font.weight.bold};
  }

  .fc .fc-toolbar.fc-header-toolbar {
    margin: 0;
    padding: 0.5rem 1.5rem;
    height: 8rem;
  }

  .fc .fc-daygrid-day.fc-day-today {
    background: ${theme.color.primary7};
    color: white!important;
  }

  .fc-header-toolbar {
    background-color: ${theme.color.white};
    color: ${theme.color.black};
    padding: 0.5rem 1rem;
  }

  .fc-highlight {
    background-color: ${theme.color.primaryA7};
  }

  .fc-theme-standard td, .fc-theme-standard th {
    border-right: none;
  }

  .fc .fc-today-button {
    background-color: ${theme.color.slate5};
    color: ${theme.color.slate11};
    padding: 0.5rem 0.5rem;
  }

  .fc-daygrid {
    border-radius: 0.5rem;
    border-color: none;
    min-width: 4rem;
  }
  .fc-daygrid-day-number {
    font-size: ${theme.font.size.small};
  }

  .fc-col-header,
  .fc-daygrid-body {
    width: 100% !important;
  }

  .fc-daygrid-body {
    table {
      height: 100%;
      width: 100% !important;
    }
  }

  .fc-scrollgrid {
    border: none !important;
    padding: 0.5rem 0.5rem 0rem 0.5rem;
    width: 32rem;
  }


  .fc-scrollgrid td:last-of-type {
    border-right: none !important;
    border-bottom: none !important; 
  }
  
  .fc-col-header-cell {
    padding: 0;
    font-weight: ${theme.font.weight.bold};
    font-size: ${theme.font.size.small};
  }

`;
